import { Route, Routes } from 'react-router-dom';
import ManageCalculations from '../../pages/manage_calculations/ManageCalculations';
import StdPattern from '../../pages/manage_calculations/StdPattern';
import StdHistorical from '../../pages/manage_calculations/StdHistorical';

const ManageCalculationsRoutes = () => {
    return <Routes>
        <Route
            path='/'
            element={<ManageCalculations/>}
        />
        <Route 
            path='/std-pattern'
            element={<StdPattern />}
        />
        <Route 
            path='/std-historical'
            element={<StdHistorical />}
        />
    </Routes>
}

export default ManageCalculationsRoutes;